// extracted by mini-css-extract-plugin
export default {"root":"Questions_root__1NTs4","title":"Questions_title__-xG_I","copy":"Questions_copy__14ui3","bg":"Questions_bg__3r8uJ"};